/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@lm-nx-frontend/lm-inf-core';
import { IconModule } from '@lm-nx-frontend/lm-inf-ui';
import { CartItemValidationWarningComponent } from './cart-item-validation-warning.component';

@NgModule({
  imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule],
  exports: [CartItemValidationWarningComponent],
  declarations: [CartItemValidationWarningComponent],
})
export class CartItemValidationWarningModule {}
